// Every endpoint the app talks to, mirroring backend/core/*/API/urls.py.
const endpoints = {
  // catalogue
  homeCategories: () => "home/categories/",
  homeBanners: () => "home/banners/",
  categories: () => "categories/",
  category: (slug) => `category/${slug}/`,
  series: () => "series/",
  movie: (id) => `movie/${id}/`,
  serie: (id) => `serie/${id}/`,
  actor: (id) => `actor/${id}/`,
  search: (query) => `search/?q=${encodeURIComponent(query)}`,

  // playback — POST, token required
  play: (type, id) => `play/${type}/${id}/`,
  live: (slug) => `live/${slug}/`,

  // reactions — POST. `target` is "movie" | "serie" | "episode".
  like: (target, id) => `like/${target}/${id}/`,
  dislike: (target, id) => `dislike/${target}/${id}/`,
  bookmark: (target, id) => `account/bookmark/${target}/${id}/`,

  // story images used by the share sheet
  story: (type, id) =>
    `${type === "portfolio" ? "portfolio-story" : "movie-story"}/${id}/`,

  // account
  profile: () => "account/profile/",
  purchasedList: () => "account/purchased/list/",
  paymentList: () => "account/payment/list/",
  profileUpdate: () => "account/profile/update/",
  membershipLevels: () => "membership/levels/",
  membershipCheckout: (id) => `membership/membership_checkout/${id}/`,

  // OTP auth
  sendLoginCode: () => "account/verify/send/login/",
  loginToken: () => "account/login/token/",
  sendRegisterCode: () => "account/verify/send/register/",
  checkCode: () => "account/verify/check/",
  register: () => "account/register/",
};

/** Lives on the /payment/ prefix, not /api/v1/. */
export const paymentEndpoints = {
  validateCoupon: () => "validate-coupon/",
};

export default endpoints;
